<template>
    <v-container fluid>
        <v-row class="mx-0">
            <v-col
                class="title mt-2"
                cols="12"
            >
                Archives
            </v-col>
            <v-col
                class="company"
                cols="12"
            >
                {{ companyName }} Archives
            </v-col>
            <v-col cols="12">
                <v-data-table
                    id="archives-list-table"
                    :headers="headers"
                    :items="showData"
                    :items-per-page="itemsPerPage"
                    hide-default-header
                    hide-default-footer
                    class="table-elevation"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <thead>
                            <tr>
                                <th
                                    v-for="h in headers"
                                    :key="h.text"
                                    class="table-th"
                                    :style="{'text-align': h.align}"
                                >
                                    <span>{{ h.text }}</span>
                                </th>
                            </tr>
                        </thead>
                    </template>
                    <template v-slot:[`item.download`]="{item}">
                        <v-btn
                            icon
                            :href="`${newtinDomain}/NewtinWeb/proServe_NJS.njs?oper=getAttachment&rowid=${encodeURIComponent(guidNormal(item.rowid))}`"
                            target="_blank"
                        >
                            <v-icon>mdi-tray-arrow-down</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:[`item.seq_date_range`]="{item}">
                        {{ formatDate(item.seq_date_from) }} thru {{ formatDate(item.seq_date_to) }}
                    </template>
                </v-data-table>
                <v-divider />
                <v-toolbar
                    id="main-tickets-table-footer"
                    flat
                >
                    <span class="showing-tickets-text">{{ showingTicketsText }}</span>
                    <v-spacer />
                    <span>Display </span>
                    <div class="pagination-select">
                        <select
                            v-model="itemsPerPage"
                            @change="resetPagination"
                        >
                            <option
                                v-for="option in perPageChoices"
                                :key="option.text"
                                :value="option.value"
                            >
                                {{ option.text }}
                            </option>
                        </select>
                        <v-icon
                            class="pagination-select-icon"
                        >
                            expand_more
                        </v-icon>
                    </div>
                    <span> Entries</span>
                    <v-spacer />
                    <v-spacer />
                    <div
                        class="pagination-container"
                    >
                        <v-pagination
                            v-model="page"
                            :length="pageCount"
                            @input="updatePageData"
                        />
                    </div>
                </v-toolbar>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';
import constants from '@/constants';
import { guidNormal } from '@/utils/guid.js';

export default {
    data: () => ({
        headers: [
            {text: 'Stage', value: 'stage', align: 'left'},
            {text: 'Seq Date Range', value: 'seq_date_range', align: 'left'},
            {text: 'Tickets', value: 'output_tickets', align: 'right'},
            {text: 'Download', value: 'download', align: 'center'}
        ],
        data: [],
        showData: [],
        page: 1,
        pageInput: 0,
        itemsPerPage: 15,
        firstTicketShowing: 0,
        lastTicketShowing: 0,
        totalTicketsCount: 0,
        perPageChoices: [
            {text:'15' , value: 15},
            {text:'25' , value: 25},
            {text:'50' , value: 50},
            {text:'100' , value: 100},
            {text:'250' , value: 250},
            {text:'500' , value: 500},
        ],
        newtinDomain: constants.NEWTIN_DOMAIN || ''
    }),
    computed: {
        companyName() {
            return this.$store.getters.company.company;
        },
        showingTicketsText() {
            return `Showing ${this.firstTicketShowing} to ${this.lastTicketShowing} of ${this.totalTicketsCount} Results`;
        },
        pageCount() {
            return Math.ceil(this.data.length / this.itemsPerPage);
        },
        getUserDetails() {
            return this.$store.getters.user;
        },
    },
    async mounted() {
        const archivesData = await webtmsBackend.getArchives();
        this.data = archivesData.companyArchives.monthlyTickets.map(d => {
            if (d.processed) {
                if (d.final_version)
                    d.stage = 'Final';
                else
                    d.stage = 'Ready';
            } else d.stage = 'Queued';
            return d;
        });
        this.updatePageData();
        this.totalTicketsCount = archivesData.companyArchives.monthlyTickets.length;
    },
    methods: {
        guidNormal(g) {
            return guidNormal(g);
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        updatePageData() {
            this.showData = this.data.slice((this.page-1)*this.itemsPerPage, (this.page-1)*this.itemsPerPage+this.itemsPerPage);
            this.firstTicketShowing = (this.page-1)*this.itemsPerPage+1;
            this.lastTicketShowing = (this.page-1)*this.itemsPerPage+this.showData.length;
        },
        resetPagination() {
            this.page = 1;
            this.updatePageData();
        },
    }
};
</script>
<style scoped>
    .title {
        font-size: 20px;
    }
    .company {
        font-size: 16px;
        font-weight: 500;
    }
    .table-elevation {
        box-shadow: 0px 1px 1px -1px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
    }
    .table-th {
        background-color: #F5F7FA;
    }
</style>